import React from 'react';
import { InvoiceInfos } from '../InvoiceInfos';
import { formatCurrency } from '@/utils/Formatters/formatCurrency';
import { IconInfo, Tooltip } from 'gatorcomponents';
import * as Styles from './InvoiceDetails.styles';

const InvoiceDetails = ({
  mobile,
  invoiceInfosProps,
  invoice,
  invoiceDetailsData,
  invoiceDetailsLocale,
}) => (
  <>
    {mobile && <InvoiceInfos {...invoiceInfosProps()} />}
    <Styles.DetailsWrapper>
      {invoiceDetailsData && invoiceDetailsData.invoiceItems.map(item => (
        <Styles.DetailsItem key={item.id}>
          <Styles.DetailsTextContainer truncableText>{item.description}</Styles.DetailsTextContainer>
          <Styles.DetailsTextContainer>{formatCurrency(item.amount)}</Styles.DetailsTextContainer>
        </Styles.DetailsItem>
      ))}
      <Styles.FinancialTable>
        <Styles.TableRow>
          <Styles.TableData>{invoiceDetailsLocale.subtotal}</Styles.TableData>
          <Styles.TableData>{formatCurrency(invoiceDetailsData.invoice.subtotal)}</Styles.TableData>
        </Styles.TableRow>

        {invoice.tax > 0 && (
          <>
            <Styles.TableRow noPaddingBottom={invoice.extraTaxes && !!invoice.extraTaxes.length}>
              <Styles.TableData>{invoiceDetailsLocale.taxes}</Styles.TableData>
              <Styles.TableData>{formatCurrency(invoice.tax)}</Styles.TableData>
            </Styles.TableRow>
            {invoice.extraTaxes && invoice.extraTaxes.map((tax, index) => (
              <Styles.TableRow
                key={`${tax.taxName}-table-row`}
                noPaddingBottom={invoice.extraTaxes.length >1 && index === 0}
                isVat
              >
                <Styles.TableData isVat>
                  {`VAT: ${tax.taxRate}% ${tax.taxName}`}
                  <Tooltip width={242} content={invoiceDetailsLocale.vatTooltip(tax.taxRate)}>
                    <IconInfo color="lowMedium" size="sm" />
                  </Tooltip>
                </Styles.TableData>
                <Styles.TableData>{formatCurrency(tax.taxTotal)}</Styles.TableData>
              </Styles.TableRow>
            ))}
          </>
        )}

        {invoiceDetailsData.invoice.credit > 0 && (
        <Styles.TableRow>
          <Styles.TableData>{invoiceDetailsLocale.credits}</Styles.TableData>
          <Styles.TableData>{`-${formatCurrency(invoiceDetailsData.invoice.credit)}`}</Styles.TableData>
        </Styles.TableRow>
        )}

        {invoiceDetailsData.invoice.amountpaid > 0 && (
        <Styles.TableRow>
          <Styles.TableData>{invoiceDetailsLocale.amountPaid}</Styles.TableData>
          <Styles.TableData>{`-${formatCurrency(invoiceDetailsData.invoice.amountpaid)}`}</Styles.TableData>
        </Styles.TableRow>
        )}

        <Styles.TableRow paddingTop noPaddingBottom>
          <Styles.TableData>{invoiceDetailsLocale.total}</Styles.TableData>
          <Styles.TableData>{formatCurrency(invoiceDetailsData.invoice.total)}</Styles.TableData>
        </Styles.TableRow>
      </Styles.FinancialTable>
    </Styles.DetailsWrapper>
  </>
);

export default InvoiceDetails;
